<template>
  <div id="reportingPage" class="page white" refs="reportingPage">
    <el-container class="content-aside">
      <el-main class="cpl-main">
        <el-row class="options monthts-filter-search" :gutter="20">
          <el-tag v-for="(date, indx) in dateFilterOptions" :key="indx"
            :class="[ `val-${date.monthLabel}`, { 'selected': selectedDateFilter === date.value || !selectedDateFilter && date.isCurrentMonth }]">
            <div class="background-color"></div>
            <div @click="handleDateFilterClick($event, date, indx)" class="tag-val">
              {{date.monthLabel}}
            </div>
          </el-tag>

          <div class="search common-search">
            <reporting-search-bar
              :selectedDateFilterProp="selectedDateFilter"
              :ref="'reportingSearchBar'"
              :reportProp="report"
              :tagsProp="selectedTagsFromSlider"
              @reporting-search-bar-change="handleReportingSearchBarChange($event)">
            </reporting-search-bar>
          </div>
        </el-row>

        <tag-slider :accessorComponentProp="'reportingPage'"
          :refreshTagSliderProp="refreshTagSlider"
          @tag-slider-change="handleTagSliderChange($event)">
        </tag-slider>

        <el-row :gutter="20" class="reporting-content-row section-wrapper">
          <div id="paginationWrapper">
            <div class="pages-wrapper">
              <Paginator
                class="py-4"
                :current-page="paginatorData.currentPage"
                :total-pages="paginatorData.totalPages"
                :min-items-count="paginatorData.minItemsCount"
                :max-items-count="paginatorData.maxItemsCount"
                :total-items-count="paginatorData.totalItemsCount"
                @page-select="handlePageSelect"
              />
            </div>
          </div>
          <div id="reportContent" v-if="report.itemsToShow.activity.monitoring.length">
            <div id="playersReport">
              <div class="player-rep-column download-report">
                <div class="row r1 icon-wrapper">
                  <div class="download-icon" @click="handleDownloadReport"></div>
                </div>
                <div class="row r2 name"></div>
                <div class="row r3 uptime-row value"></div>
                <div class="row r4 online-row val"></div>
                <div class="row r5 restart-row val"></div>
              </div>
              <div class="player-rep-column row-txt-label">
                <div class="row r1 icon-wrapper"></div>
                <div class="row r2 name"></div>
                <div class="row r3 uptime-row value"><div class="cell">{{$t('label.upTime')}}</div></div>
                <div class="row r4 online-row val"><div class="cell">{{$t('label.online')}}</div></div>
                <div class="row r5 restart-row val"><div class="cell">{{$t('label.restart')}}</div></div>
              </div>

              <template v-for="(item, indx) in report.itemsToShow.activity.monitoring" :key="indx">
                <div class="player-rep-column player-item">
                  <div class="row r1 icon-wrapper"><div v-if="!item.emptyColumn" :class="['icon', item.deviceType]"></div></div>
                  <div class="row r2 name"><div v-if="!item.emptyColumn"  class="cell"><span>{{item.name}}</span></div></div>
                  <div class="row r3 uptime-row value txt"><div v-if="!item.emptyColumn" class="cell">{{item._edit.averageUptime}}</div></div>
                  <div class="row r4 online-row value txt"><div v-if="!item.emptyColumn" class="cell">{{item._edit.averageOnlineTime}}</div></div>
                  <div class="row r5 restart-row value txt"><div v-if="!item.emptyColumn" class="cell">{{item._edit.numberOfRestarts}}</div></div>
                </div>
              </template>

              <img @load="calculateMediaListHeight" src="../../../static/images/load-flag-event.png">
            </div>

            <!-- Media  -->
            <div v-if="showMediaSummary && report.itemsToShow.activity.mediaInPlayer.length" id="mediaReport" class="hide-scrollbar" :style="mediaContentStyle">
              <div class="player-rep-column download-report">
                <div :class="['row', `r-label`]">
                  <div class="media-preview-column"></div>
                  <div class="media-name-column"></div>

                  <template v-for="(player, indx) in report.itemsToShow.activity.monitoring" :key="indx">
                    <div class="player-column">
                      <div class="cell">
                        <div v-if="!player.emptyColumn" class="val">
                          <div class="days-played">{{'days'}}</div>
                          <div class="times-played">{{'plays/day'}}</div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="media-list-wrapper">
                  <div class="media-list-content hide-scrollbar">
                    <div v-for="(media, indx) in report.itemsToShow.activity.mediaInPlayer" :key="indx" :class="['row', `r${indx}`]">
                      <div class="media-preview-column">
                        <div class="cell">
                          <div class="media-preview">
                            <template v-if="media.hasOwnProperty('preview') && media.preview !== null">
                              <!-- Image Preview -->
                              <img v-if="media.preview.type === 'img'" :src="$utils.filterMediaPreviewUrl(media.preview.url)" class="object-fit_cover_center">

                              <!-- Project Preview -->
                              <template v-if="['svg', 'html'].indexOf(media.preview.type) >= 0">
                                <iframe :id="`mediaProjectFile_${media.resourceId}`"
                                  :src="$utils.filterMediaPreviewUrl(media.preview.url)"
                                  :class="['object-fit_cover_center', 'template-target-on-refresh-token', 'media-project-file', `media-preview-${media._edit.uid}`]">
                                </iframe>
                              </template>
                            </template>

                            <!-- No Preview -->
                            <template v-if="!media.hasOwnProperty('preview') || media.preview === null">
                              <div class="no-preview">
                                <div class="np-content">
                                  <el-icon class="icon"><PictureFilled /></el-icon>
                                  {{$t('label.previewUnavailable')}}
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="media-name-column">
                        <div class="cell"><span>{{media.name}}</span></div>
                      </div>
                      <template v-for="(player, indx) in media.monitoring" :key="indx">
                        <div class="player-column">
                          <div class="cell">
                            <div v-if="player.playedInPlayer" class="val">
                              <div class="days-played">{{player.playedInPlayer.numberOfDaysPlayed}}</div>
                              <div class="times-played">{{player.playedInPlayer.averageTimesPlayed}}</div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script src="./reporting.js"></script>
<style lang="scss" src="./reporting.scss"></style>
